<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- TOOLTIPS -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              TOOLTIPS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <p class="mt-4">
              Tooltipler padding özelliğinde
              <b>4px 8px</b> değerlerini kullanır.
              <b>@xxs</b> font ile doldurulular. Genellikle
              <b>'Uppercase'</b> karakterler içerirler. Azami <b>200px</b> uzunluğunda olabilir. Bu uzunluk altında içerik kadar uzar. <b>5</b> satirdan fazla açıklama içermesi önerilmez.
            </p>
            <b-row class="mt-4">
              <div class="col-2">
                <b-btn v-b-tooltip.hover.top="'tooltip!'"
                       class="btn md bg-pale-grey text-purple"
                >
                  Top
                </b-btn>
              </div>
              <div class="col-2">
                <b-btn v-b-tooltip.hover.right="'tooltip!'"
                       class="btn md bg-pale-grey text-purple"
                >
                  Right
                </b-btn>
              </div>
              <div class="col-2">
                <b-btn v-b-tooltip.hover.left="'tooltip!'"
                       class="btn md bg-pale-grey text-purple"
                >
                  Left
                </b-btn>
              </div>
              <div class="col-2">
                <b-btn v-b-tooltip.hover.bottom="'tooltip!'"
                       class="btn md bg-pale-grey text-purple"
                >
                  Bottom
                </b-btn>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-2">
                <b-btn v-b-tooltip.hover.top="'Are you ready to buy a home theater audio system? Here are several tips to help you find the right audio system for you.!'"
                       class="btn md bg-pale-grey text-purple"
                >
                  Top
                </b-btn>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Tooltip',
  data() {
    return {};
  },
  computed: {},
};
</script>
